<h5 class="dialog-title fw-bold">{{data.title}}</h5>
<div class="p-4" mat-dialog-content>
  <form [formGroup]="form">
    <p class="text-break">{{data.text}}</p>
    @if (data.isRifiuto) {
    <div class="row g-3 mb-3">
      <div class="col-12">
        <label class="form-label" for="motivoRifiuto" [class.required]="isRequired('motivoRifiuto')">
          {{data.isRifiutoLabel}}
        </label>
        <input type="text" id="motivoRifiuto"
          formControlName="motivoRifiuto"
          class="form-control"
          maxlength="500">
        @if((form.get('motivoRifiuto')?.errors?.['required'] ||
        form.get('motivoRifiuto')?.errors?.['incorrect'])
        && form.get('motivoRifiuto')?.touched) {
        <div class="invalid-feedback">Il campo è obbligatorio</div>
        }
        @if((!form.get('motivoRifiuto')?.errors?.['required'] && form.get('motivoRifiuto')?.errors?.['whitespace'])
        && form.get('motivoRifiuto')?.touched) {
        <div class="invalid-feedback">Il campo non è valido</div>
        }
      </div>
    </div>
    }
  </form>
</div>
<div mat-dialog-actions class="p-4 d-flex justify-content-end">
  <button
    (click)="reject()"
    type="button"
    [className]="'btn me-4 ' +(data.btnStyle ? 'btn-outline-'+data.btnStyle : 'btn-outline-primary') "
  >
    {{data.rejectBtnTxt ?? 'Annulla'}}
  </button>
  <button
    (click)="confirm()"
    type="button"
    [disabled]="form.invalid"
    [className]="'btn ' + (data.btnStyle ? 'btn-'+data.btnStyle : 'btn-primary') "
  >
    {{data.confirmBtnTxt ?? 'Conferma'}}
  </button>
</div>
